import { z } from 'zod'
import { objectToCamel } from 'ts-case-convert'

//* ---------------- BASE ---------------- *//
export const searchTypeSchema = z.union([
  z.literal('fabric'),
  z.literal('collection'),
  z.literal('customer'),
  z.literal('order'),
  z.literal('garment'),
  z.literal('dealer'),
  z.literal('option'),
  z.literal('option_value'),
])
//* ---------------- SCHEMAS ---------------- *//
export const searchSchema = z
  .object({
    id: z.number(),
    type: searchTypeSchema,
    name: z.string(),
    datetime: z.coerce.date().nullable(),
    description: z.string().nullable(),
    reference_id: z.number().nullable(),
  })
  .transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  namespace TrinityAPI {
    type SearchType = z.infer<typeof searchSchema>
    type SearchTypeType = z.infer<typeof searchTypeSchema>
  }
}
